import { updatesItems } from '@/mocks/homepage';

export default function UpdatesSection() {
  return (
    <section id="updates" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-600">关注春夜影院的最新变化，不错过每一次更新</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-0 top-0 bottom-0 w-px bg-background-300/60"></div>
            {updatesItems.map((item, i) => (
              <div key={item.id} className="relative pb-10 last:pb-0">
                <div className={`absolute left-[-33px] md:left-[-37px] top-1 w-4 h-4 rounded-full border-2 ${
                  i === 0 ? "bg-accent-500 border-accent-500" : "bg-background-100 border-secondary-400"
                }`}></div>
                <div className="ml-4">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
                      item.tag === "上新" ? "bg-primary-100 text-primary-700" :
                      item.tag === "专题" ? "bg-accent-100 text-accent-700" :
                      item.tag === "升级" ? "bg-secondary-100 text-secondary-700" :
                      item.tag === "里程碑" ? "bg-primary-100 text-primary-700" :
                      "bg-foreground-100 text-foreground-600"
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}